.root {
  container-type: inline-size;
}

.row {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 4px 8px;
  padding: 4px 0;
}
.row + .row {
  border-top: 1px solid rgba(128, 128, 128, 0.25);
}

.close {
  flex: 0 0 auto;
}

.cell {
  flex: 0 1 auto;
  min-width: 0;
}
.cell[data-field=ref] {
  flex: 1 1 12em;
}

@container (max-width: 575px) {
  .cell[data-field=ref] {
    flex-basis: 100%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIklucHV0QXJyYXlGbGV4LnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTs7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBQ0U7OztBQUVKO0VBQ0U7OztBQUVGO0VBQ0U7RUFDQTs7QUFHQTtFQUNFOzs7QUFHSjtFQUNFO0lBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIucm9vdFxuICBjb250YWluZXItdHlwZTogaW5saW5lLXNpemVcblxuLnJvd1xuICBkaXNwbGF5OiBmbGV4XG4gIGZsZXgtZmxvdzogcm93IHdyYXBcbiAgYWxpZ24taXRlbXM6IGNlbnRlclxuICBnYXA6IDRweCA4cHhcbiAgcGFkZGluZzogNHB4IDBcblxuICAmICsgLnJvd1xuICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCByZ2JhKDEyOCwgMTI4LCAxMjgsIC4yNSlcblxuLmNsb3NlXG4gIGZsZXg6IDAgMCBhdXRvXG5cbi5jZWxsXG4gIGZsZXg6IDAgMSBhdXRvXG4gIG1pbi13aWR0aDogMFxuXG4gIC8vIFRoZSBpbmdyZWRpZW50IHNlYXJjaCBkZXNlcnZlcyBhbGwgdGhlIHdpZHRoIGxlZnQgb3ZlclxuICAmW2RhdGEtZmllbGQ9XCJyZWZcIl1cbiAgICBmbGV4OiAxIDEgMTJlbVxuXG4vLyBQaG9uZS1uYXJyb3cgY29udGFpbmVyOiB0aGUgc2VhcmNoIG1vdmVzIHRvIGl0cyBvd24gbGluZVxuQGNvbnRhaW5lciAobWF4LXdpZHRoOiA1NzVweClcbiAgLmNlbGxbZGF0YS1maWVsZD1cInJlZlwiXVxuICAgIGZsZXgtYmFzaXM6IDEwMCVcbiJdfQ== */